import React from 'react';
import { Cloud, Target, Wrench, Brain, ArrowRight, ChevronRight, GraduationCap, MessagesSquare, Star } from 'lucide-react';
import { useState } from 'react';


const App = () => {
  const [showImage, setShowImage] = useState(false);  // Add this line at the top
  const [isRed, setIsRed] = useState(false);
  const [showScottImage, setShowScottImage] = useState(false);
  const [showDockerImage, setShowDockerImage] = useState(false);
  const [showyahtImage, setshowyahtImage] = useState(false);


  return (
    <div className="min-h-screen bg-black text-white">
      {/* Hero Section */}
      <div className="relative min-h-[70vh] flex items-center justify-center overflow-hidden bg-gradient-to-br from-neutral-950 to-neutral-900">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(227,24,55,0.1),transparent_50%)]" />
        </div>
        
        <div className="relative z-10 container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="inline-flex items-center space-x-2 px-4 py-2 bg-red-600/10 rounded-full text-red-500 text-sm mb-6">
              <Cloud className="h-4 w-4" />
              <span>Cloud Migration Researcher</span>
            </div>
            <h1 className="text-6xl font-bold mb-6">
              FREE Intern
              <span 
                className={`
                  text-green-500 cursor-pointer transition-all duration-300
                  hover:text-green-400 hover:scale-110
                  ${!showImage ? 'animate-pulse' : ''}
                  inline-block
                  drop-shadow-[0_-2px_2px_rgba(239,68,68,0.3)]
                `}
                onClick={() => {
                  setShowImage(true);
                  setIsRed(true);
                  setTimeout(() => {
                    setShowImage(false);
                    setIsRed(false);
                  }, 3000);
                }}
                style={{ color: isRed ? '#EF4444' : undefined }}
              >
              ³¹
              </span>
              {' '}at{' '}
              <span className="text-red-500">Linedata</span>
            </h1>
            {showImage && (
                <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50">
                  <div className="bg-black/90 p-4 rounded-xl shadow-2xl scale-in-center">
                    <img
                      src="Entar31.png"
                      alt="Intern 31 Badge"
                      className="max-w-sm rounded-lg shadow-lg transform transition-all duration-300 hover:scale-105"
                    />
                  </div>
                </div>
              )}
            <p className="text-xl text-gray-400 max-w-2xl">
              Life Altering On-Site Experience. Breaking early barriers & pursuing growth through asset management.
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-6 py-24 space-y-24">
        {/* Personal Journey Section */}
        <div className="max-w-3xl mx-auto">
          <div className="bg-neutral-900/50 p-8 rounded-3xl border border-neutral-800 space-y-6">
            <div className="flex items-center gap-3">
              <GraduationCap className="h-6 w-6 text-red-500" />
              <h2 className="text-2xl font-bold">It was highly unlikely.</h2>
            </div>
            <p className="text-gray-400 leading-relaxed">
              I never had real experience before this, I was simply hungry for one—each step forward was breaking new ground.
            </p>
            <p className="text-gray-400 leading-relaxed">
              Before this onsite experience, I prepared myself through an <span 
                className={`
                  font-bold text-red-400 hover:text-red-300 underline decoration-dotted underline-offset-4 transition-colors cursor-pointer
                  ${!showyahtImage ? 'animate-pulse' : ''}
                `}
                onClick={() => {
                  setshowyahtImage(true);
                  setTimeout(() => {
                    setshowyahtImage(false);
                  }, 3000);
                }}
              >online internship</span> that introduced me to Microsoft Teams and the modern workplace. Foregoing a <a 
                          href="https://istic.computer-engineering.tech/?#/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-red-400 hover:text-red-300 underline decoration-dotted underline-offset-4 transition-colors"
                  >fluky '20 istic entry</a> to pass the firsṰ2(hardest) semesters, after which I liberated countless times spent acquiring <a 
                          href="https://cert.yah.qa/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-red-400 hover:text-red-300 underline decoration-dotted underline-offset-4 transition-colors"
                  >certs</a>, feeding my soul, and using education to rise above my circumstances until securing this next June.
            </p>
            {showyahtImage && (
            <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50">
              <div className="bg-black/90 p-4 rounded-xl shadow-2xl scale-in-center">
                <img
                  src="/1719373892361.jpeg"
                  alt="Yahya Internship"
                  className="max-w-sm rounded-lg shadow-lg"
                />
              </div>
            </div>
          )}
            <div className="mt-6 p-4 bg-red-500/10 rounded-xl border border-red-500/20">
              <p className="text-red-400 italic">
                "While the internship was unpaid, the access to onsite Office, teams & infrastructure and real-world experience was invaluable for my growth."- Yahya Abulhaj, An undergrad with 0XP.
              </p>
            </div>
          </div>
        </div>

        <div className="max-w-3xl mx-auto space-y-8">
          {/* Achievements Container */}
          <div className="bg-neutral-900/50 p-8 rounded-3xl border border-neutral-800">
            <h2 className="text-2xl font-bold mb-8 flex items-center gap-3">
              <Star className="h-6 w-6 text-red-500" />
              Certifications During Internship
            </h2>
            
            <div className="space-y-6">
              {/* AWS Certification */}
              <div className="group p-4 bg-gradient-to-r from-[#FF9900]/5 to-transparent rounded-2xl border border-[#FF9900]/20 hover:border-[#FF9900]/40 transition-all">
                <div className="flex items-center gap-4">
                  <div className="p-3 bg-[#FF9900]/10 rounded-xl">
                    <svg className="w-8 h-8 text-[#FF9900]" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M18.75 9.87v4.26L24 12zm-6.25 8.13v4.25L18.75 20v-4.25zm-6.25-4.25v4.26L12.5 16zm-6.25.38L6.25 16v-4.25L0 9.87zm6.25-8.13L0 9.87l6.25 1.88V7.5zM12.5 2L6.25 5.87V11l6.25-3.88zm6.25 3.87L12.5 2v6l6.25 1.87zM12.5 16l6.25 1.88V13.5L12.5 11.75z"/>
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-semibold text-xl text-[#FF9900]">Studied AWS Cloud Practitioner Curriculum</h3>
                    <p className="text-gray-400 mt-1">Foundation for the cloud infrastructure of Linedata (<a 
                href="https://secure.yah.qa/creds/ground/aws/practitioner.pdf" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-red-400 hover:text-red-300 underline decoration-dotted underline-offset-4 transition-colors"
                  >Passed</a> later)</p>
                  </div>
                </div>
              </div>

              {/* Azure Certification - Made More Prominent */}
              <div className="group p-6 bg-gradient-to-r from-[#008AD7]/10 to-transparent rounded-2xl border border-[#008AD7]/20 hover:border-[#008AD7]/40 transition-all">
                <div className="flex items-center gap-4">
                  <div className="p-3 bg-[#008AD7]/10 rounded-xl">
                    <svg className="w-8 h-8 text-[#008AD7]" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2L2 7.5v9L12 22l10-5.5v-9L12 2zm0 2.3l7.5 4.1L12 12.5 4.5 8.4 12 4.3zm-8.5 5.9L11 14.5v5.9l-7.5-4.1v-6.1zm17 0v6.1L13 20.4v-5.9l7.5-4.3z"/>
                    </svg>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-3">
                      <h3 className="font-semibold text-xl text-[#008AD7]">Azure Network Engineer Associate (AZ-700)</h3>
                      <span className="px-2 py-1 bg-[#008AD7]/20 rounded-full text-xs text-[#008AD7] font-medium"><a 
                href="https://secure.yah.qa/creds/associate/msft/az-700.pdf" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-red-400 hover:text-red-300 underline decoration-dotted underline-offset-4 transition-colors"
                  >Game Changer</a> - <a 
                href="https://secure.yah.qa/creds/associate/msft/novo/AZAB700.pdf" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-red-400 hover:text-red-700 underline decoration-dotted underline-offset-4 transition-colors"
                  >NOVO</a></span>
                    </div>
                    <p className="text-gray-400 mt-2 leading-relaxed">
                      A pivotal achievement that dramatically elevated my cloud networking expertise and opened doors to unprecedented opportunities.
                    </p>
                  </div>
                </div>
              </div>

              {/* Achievement Impact */}
              <div className="mt-6 p-4 bg-red-500/10 rounded-xl border border-red-500/20">
              <p className="text-gray-400 leading-relaxed">
                Securing the advanced <span className="font-bold text-red-600 border-b-2 border-red-600">AZ-700</span> during the internship by month <span className="font-bold text-red-600 border-b-2 border-red-600">07</span> (Seventh) demonstrated not just technical proficiency but an ability to rapidly adapt and excel under pressure.
              </p>
              </div>
            </div>
          </div>

        </div>

        {/* Key Learnings Grid */}
        <div className="space-y-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Tools & Technologies */}
            <div className="group relative">
              <div className="absolute inset-0 bg-gradient-to-r from-red-600 to-red-900 opacity-0 group-hover:opacity-100 rounded-3xl transition-opacity duration-500" />
              <div className="relative p-8 bg-neutral-900 rounded-3xl h-full border border-neutral-800 group-hover:border-transparent transition-colors">
                <div className="flex items-center gap-4 mb-6">
                  <Wrench className="h-6 w-6 text-red-500" />
                  <h2 className="text-2xl font-bold">Technical Arsenal</h2>
                </div>
                <p className="text-gray-400 leading-relaxed">
                  Mastered a diverse range of cloud services, DevOps tools, and server-side scripting, building a comprehensive technical foundation.
                </p>
              </div>
            </div>

            {/* Adaptability */}
            <div className="group relative">
              <div className="absolute inset-0 bg-gradient-to-r from-red-600 to-red-900 opacity-0 group-hover:opacity-100 rounded-3xl transition-opacity duration-500" />
              <div className="relative p-8 bg-neutral-900 rounded-3xl h-full border border-neutral-800 group-hover:border-transparent transition-colors">
                <div className="flex items-center gap-4 mb-6">
                  <Brain className="h-6 w-6 text-red-500" />
                  <h2 className="text-2xl font-bold">Key Insights</h2>
                </div>
                <p className="text-gray-400 leading-relaxed">
                  Learned the importance of adaptability in tech, embracing continuous learning and perseverance as core values.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* FAQ/Reflections Section */}
        <div className="max-w-3xl mx-auto">
          <div className="space-y-8">
            <h2 className="text-3xl font-bold mb-8 flex items-center gap-3">
              <MessagesSquare className="h-8 w-8 text-red-500" />
              1 Month Reflection (Got A KPMG Offer)
            </h2>


              <div className="bg-neutral-900/50 p-6 rounded-2xl border border-neutral-800">
                <h3 className="font-semibold text-xl mb-3">²What tools yah used?</h3>
                <p className="text-gray-400">
                  I worked with a comprehensive stack including cloud services, DevOps tools, and server-side scripting technologies all while harness-ing-.io interaction with others.
                </p>
            </div>
            <div className="space-y-6">
              <div className="bg-neutral-900/50 p-6 rounded-2xl border border-neutral-800">
                <h3 className="font-semibold text-xl mb-3">³What was your position?</h3>
                <p className="text-gray-400">
                  I was assigned to the cloud migration project. I excelled in my role, progressing faster than those who had been enrolled for months.
                </p>
              </div>

              <div className="bg-neutral-900/50 p-6 rounded-2xl border border-neutral-800">
                <h3 className="font-semibold text-xl mb-3">⁴What did you struggle with?</h3>
                <p className="text-gray-400">
                  Transportation and financial constraints were challenging. Working with Tunisian companies presented unique experiences in terms of wasta & nepotism workplace culture.
                </p>
              </div>

              <div className="bg-neutral-900/50 p-6 rounded-2xl border border-neutral-800">
                <h3 className="font-semibold text-xl mb-3">⁵Why did you leave before summer's end?</h3>
                <p className="text-gray-400">
                  While I was welcome to stay longer, I had accelerated through my learning objectives and found another opportunity (LinkedIn DM from a HR) that aligned with my rapid growth trajectory.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Success Philosophy */}
        <div className="max-w-3xl mx-auto">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-red-600/20 to-transparent blur-xl" />
            <div className="relative bg-neutral-900 p-8 rounded-3xl border border-neutral-800">
              <h2 className="text-2xl font-bold mb-6 flex items-center gap-3">
                <Target className="h-6 w-6 text-red-500" />
                Success Formula
              </h2>
              <p className="text-gray-400 leading-relaxed mb-6">
                Success = Wealth + Health + Time ⦿
              </p>
              <p className="text-gray-400">
                A personal equation developed through experience, focusing on creating a balanced approach to achievement over the next 5-7 years.
              </p>
              <p className="text-gray-500 mt-4 text-right">Written on 7/7/2022</p>
            </div>
          </div>
        </div>
          {/* Breakthrough Moment - Keep your existing content */}


{/* Breakthrough Moment */}
<div className="relative">
  <div className="absolute inset-0 bg-gradient-to-r from-red-600/20 to-transparent blur-xl" />
  
  <div className="relative bg-neutral-900 p-8 rounded-3xl border border-neutral-800">
    
    <div className="flex flex-col md:flex-row items-start gap-6">
      
      {/* Avatar */}
      <div className="flex-shrink-0">
        <img
          src="/bbRIGHT.png"
          alt="Avatar"
className="
  w-28 h-28
  md:w-36 md:h-36
  rounded-full
  object-contain
  bg-neutral-950
  p-1
  border-4 border-red-500/40
  shadow-[0_0_25px_rgba(239,68,68,0.25)]
  hover:scale-105
  transition-all duration-300
"
        />
      </div>

      {/* Text Content */}
      <div className="flex-1">
        <h2 className="text-2xl font-bold mb-6">
          The Turning Point ⦿
        </h2>

        <p className="text-gray-400 leading-relaxed mb-6">
          From day one, I embraced the chaos of uncertainty, constantly questioning what lay ahead. During my Third week, while juggling my internship responsibilities, I achieved something remarkable – passing the Networking Engineering certification of Azure.
        </p>

        <p className="text-gray-400 leading-relaxed">
          At 5 AM almost, after completing that Azure exam, I made a LinkedIn post before{' '}
          <a
            href="https://en.wikipedia.org/wiki/Soci%C3%A9t%C3%A9_Nationale_des_Chemins_de_Fer_Tunisiens"
            target="_blank"
            rel="noopener noreferrer"
            className="text-red-400 hover:text-red-300 underline decoration-dotted underline-offset-4 transition-colors"
          >
            catching the train station
          </a>{' '}
          to Linedata. That same day, opportunity knocked – a paid remote position I had only dreamed of. I finished One last week & entered. Sometimes, persistence creates its own luck.
        </p>
      </div>

    </div>
  </div>
</div>


{/* Next Chapter - Made More Prominent */}
<div className="text-center max-w-3xl mx-auto bg-neutral-900/50 p-12 rounded-3xl border border-neutral-800">
  <h2 className="text-3xl font-bold mb-6">The Journey Continues</h2>
  <p className="text-gray-400 mb-8">
    My time at Linedata was so defining & new opportunities beckoned. Scott Hanselman was truly my beacon of hope during this. <a 
      href="https://www.youtube.com/playlist?list=PL0M0zPgJ3HSesuPIObeUVQNbKqlw5U2Vr" 
      target="_blank" 
      rel="noopener noreferrer" 
      className="text-red-400 hover:text-red-300 underline decoration-dotted underline-offset-4 transition-colors"
    >²⁶ Computer Stuff They Didn't Teach You</a> felt like a gift from the heavens. I still <span 
      className={`
        font-bold text-red-400 hover:text-red-300 underline decoration-dotted underline-offset-4 transition-colors cursor-pointer
        ${!showScottImage ? 'animate-pulse' : ''}
      `}
      onClick={() => {
        setShowScottImage(true);
        setTimeout(() => {
          setShowScottImage(false);
        }, 3000);
      }}
    >have this of him</span> while learning <span 
      className={`
        font-bold text-red-400 hover:text-red-300 underline decoration-dotted underline-offset-4 transition-colors cursor-pointer
        ${!showDockerImage ? 'animate-pulse' : ''}
      `}
      onClick={() => {
        setShowDockerImage(true);
        setTimeout(() => {
          setShowDockerImage(false);
        }, 3000);
      }}
    >Docker</span> with <a 
      href="https://ohmyz.sh/" 
      target="_blank" 
      rel="noopener noreferrer" 
      className="text-red-400 hover:text-red-300 underline decoration-dotted underline-offset-4 transition-colors"
    >Oh My Zsh</a>.
  </p>
  {showScottImage && (
    <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50">
      <div className="bg-black/90 p-4 rounded-xl shadow-2xl scale-in-center">
        <img
          src="/HAN-REDEEM.png"
          alt="Scott Screenshot"
          className="max-w-sm rounded-lg shadow-lg"
        />
      </div>
    </div>
  )}
  {showDockerImage && (
    <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50">
      <div className="bg-black/90 p-4 rounded-xl shadow-2xl scale-in-center">
        <img
          src="/PuvM-Z-QSPKDaiOrOeYLTQ.jpg"
          alt="Docker Screenshot"
          className="max-w-sm rounded-lg shadow-lg"
        />
      </div>
    </div>
  )}
  <a 
    href="https://istic.computer-engineering.tech/#/intern" 
    className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-red-600 to-red-700 rounded-full text-white hover:from-red-700 hover:to-red-800 transition-all duration-300 shadow-lg hover:shadow-xl"
  >
    <span className="text-lg">Track Process & Next Steps</span>
    <ArrowRight className="h-5 w-5" />
  </a>
</div>

        {/* Advice Section */}
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl font-bold mb-8">Advice for Interns Sh⦿⦿ters </h2>
          <div className="space-y-4">
          <div className="flex items-start gap-3">
              <ChevronRight className="h-5 w-5 text-red-500 mt-1" />
              <p className="text-gray-400">Focus on learning and growth - it's the key to rapid progress in the field</p>
            </div>
            <div className="flex items-start gap-3">
              <ChevronRight className="h-5 w-5 text-red-500 mt-1" />
              <p className="text-gray-400">Adapt to ever-changing technologies - new cloud services are released constantly</p>
            </div>
            <div className="flex items-start gap-3">
              <ChevronRight className="h-5 w-5 text-red-500 mt-1" />
              <p className="text-gray-400">Practice patience and perseverance - mastery comes with dedicated time and effort</p>
            </div>
          </div>
          <div className="mt-12 p-6 bg-neutral-900/50 rounded-2xl border border-neutral-800">
            <p className="text-sm text-gray-400 italic">
              These reflections are sourced from original research & complete mindfulness as of that period, seek the{' '}
              <a 
                href="http://secure.yah.qa/FREE/2022/Q2/Linedata/7/reflections.pdf" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-red-400 hover:text-red-300 underline decoration-dotted underline-offset-4 transition-colors"
              >
               deep
              </a>
              .
            </p>
          </div>
        </div>
      </div>

      {/* Subtle Footer */}
      <footer className="border-t border-neutral-800/50">
        <div className="container mx-auto px-6 py-8">
          <p className="text-center text-neutral-600 text-sm">
          © 2022. Yahya. Free Interns Just Work 
          </p>
        </div>
      </footer>
    </div>
  );
};

export default App;
